import { shallowEqual, useSelector } from "react-redux"

import type { IRootState } from "@/3514/store"

import { type IParticipantHeaderState, PARTICIPANT_HEADER_REDUCER_NAME } from "./participant.header.slice"

const selector: (state: IRootState) => IParticipantHeaderState = (state: IRootState): IParticipantHeaderState =>
    state[PARTICIPANT_HEADER_REDUCER_NAME]

function useParticipantHeaderSelector(): IParticipantHeaderState {
    return useSelector(selector, shallowEqual)
}

export { useParticipantHeaderSelector }
